// extracted by mini-css-extract-plugin
export default {"layout":"layout_layout__HHxdr","content-area":"layout_content-area__84ThN"};